<script setup>
import {useBaseStore} from "~/stores/base";
import Drawer from "~/components/Drawer.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import SlideVoteIntroduce from "~/components/product/DrawerProductShare/SlideVoteIntroduce.vue";
import SlideProductShare from "~/components/product/DrawerProductShare/SlideProductShare.vue";
import {useProductStore} from "~/stores/product";

const BNTOMessage = useNuxtApp().$BNTOMessage
const router = useRouter()
const route = useRoute()

/** emits **/
const emits = defineEmits([])

/** props **/
const props = defineProps({})

/** data **/
const swiperInstance = ref(null);
const swiperSlideIndex = ref(0)

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)
const open = computed(() => useBaseStore().getterIsShowModalShare)
const shareData = computed(() => useBaseStore().getterShareData)
const voteInfo = computed(() => useProductStore().getterProductConfig.voteInfo) // 仅用来展示分享引导的标题

/** watch **/
watch(open, () => {
  if (!open.value) swiperInstance.value.slideTo(0)
})

/** methods **/
const handleClose = () => {
  useBaseStore().updateIsShowModalShare(false)
}

const onSwiper = (swiper) => {
  swiperInstance.value = swiper; // 保存 Swiper 实例
};
const onSlideChange = (e) => {
  swiperSlideIndex.value = e.activeIndex
};
const handleViewIntroduce = () => {
  swiperInstance.value.slideTo(1)
}
const handleBack = () => {
  swiperInstance.value.slideTo(0)
}
/** lifecycle **/

</script>

<template>
  <div class="drawer-product-share-mobile" v-if="isMobile">
    <Drawer
      :open="open"
      @close="handleClose"
      :btn-close-visible="false"
      :position="'bottom'"
      :border-radius="'8px 8px 0 0'"
      :z-index="4"
      :global-header-visible="false"
    >
      <div class="drawer">
        <div class="drawer-header">
          <div class="drawer-header-left">
            <div class="back" v-if="swiperSlideIndex === 1" @click="handleBack"><img src="@/assets/img/icon-arrow-left.svg" alt="icon"></div>
          </div>
          <div class="title">
            {{ swiperSlideIndex === 0 ? shareData.popTitle : voteInfo.guideTitle }}
          </div>
          <div class="close" @click="handleClose"><img src="@/assets/img/icon-close-black.svg" alt="icon"></div>
        </div>
        <div class="drawer-body">
          <swiper
            :allow-touch-move="false"
            :initial-slide="swiperSlideIndex"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
          >
            <swiper-slide>
              <slide-product-share @introduce="handleViewIntroduce"/>
            </swiper-slide>
            <swiper-slide>
              <slide-vote-introduce :swiper-slide-index="swiperSlideIndex"/>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </Drawer>
  </div>
  <div class="drawer-product-share-desktop" v-else>
    <Drawer
      :open="open"
      :position="'right'"
      :z-index="3"
      @close="handleClose"
    >
      <div class="drawer">
        <div class="drawer-header">
          <div class="drawer-header-left">
            <div class="back" v-if="swiperSlideIndex === 1" @click="handleBack"><img src="@/assets/img/icon-arrow-left.svg" alt="icon"></div>
          </div>
          <div class="title">
            {{ swiperSlideIndex === 0 ? shareData.popTitle : voteInfo.guideTitle }}
          </div>
          <div class="close" @click="handleClose"><img src="@/assets/img/icon-close-black.svg" alt="icon"></div>
        </div>
        <div class="drawer-body">
          <swiper
            :allow-touch-move="false"
            :initial-slide="swiperSlideIndex"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
          >
            <swiper-slide>
              <slide-product-share @introduce="handleViewIntroduce"/>
            </swiper-slide>
            <swiper-slide>
              <slide-vote-introduce :swiper-slide-index="swiperSlideIndex"/>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.drawer-product-share-mobile {
  .drawer {
    display: flex;
    flex-direction: column;
    max-height: 75vh;

    .drawer-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;

      .drawer-header-left {
        width: 40px;
        height: 40px;

        .back {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }

      .title {
        /* Eyebrow/medium */
        font-family: "TWK Lausanne";
        font-size: 14px;
        font-style: normal;
        font-weight: 650;
        line-height: 18px; /* 128.571% */
        letter-spacing: -0.056px;
        text-transform: uppercase;
      }

      .close {
        cursor: pointer;
        flex-shrink: 0;

        border: 1px solid $color-BNTO-beige-dark;

        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }
      }
    }

    .drawer-body {
      flex: 1;
      overflow-y: hidden;
      padding: 0 16px;
      margin-top: 16px;

      .swiper {
        height: 100%;

        .swiper-slide {
          height: 100%;
        }
      }
    }
  }
}

.drawer-product-share-desktop {
  .drawer {
    width: 432px;
    height: calc(100vh - $desktop-header-height);
    padding-top: 14px;
    display: flex;
    flex-direction: column;

    .drawer-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 16px;

      .drawer-header-left {
        width: 40px;
        height: 40px;

        .back {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }

      .title {
        font-family: "Alternate Gothic No3 D";
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 32px; /* 88.889% */
        letter-spacing: -0.36px;
        text-transform: uppercase;
        padding-top: 12px;
      }

      .close {
        cursor: pointer;
        flex-shrink: 0;

        border: 1px solid $color-BNTO-beige-dark;

        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }
      }
    }

    .drawer-body {
      flex: 1;
      overflow-y: hidden;
      padding: 0 16px;
      margin-top: 16px;

      .swiper {
        height: 100%;

        .swiper-slide {
          height: 100%;
        }
      }
    }
  }
}
</style>
